import React from "react";

export default function CurrentTemperature(props) {
  return (
    <div>
      <h1>{Math.round(props.celsius)}°</h1>
      <p>
        feels like{" "}
        <span id="felt-temp">{Math.round(props.feltCelsius)} °C</span>
      </p>
    </div>
  );
}
